import { useEffect } from 'react';

/**
 * This hook allows you to detect keyboard events on menu list and emit callback functions on "Enter", "ArrowDown" and "ArrowUp".
 * @param {number} itemsCount count of items in menu list.
 * @param {number} highlightedIndex current highlighted item index.
 * @param {Function} onArrowsCallback callback to emit on "ArrowUp" and "ArrowDown".
 * @param {Function} onEnterCallback callback to emit on "Enter" key.
 */

function useListKeyboardNavigation(
  itemsCount: number,
  highlightedIndex: number,
  onArrowsCallback: Function,
  onEnterCallback: Function
): void {
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent): void => {
      if (event.key === 'Enter') {
        onEnterCallback();
      } else {
        let newIndex;
        if (event.key === 'ArrowDown') {
          newIndex =
            highlightedIndex === null || highlightedIndex === itemsCount - 1
              ? 0
              : highlightedIndex + 1;
        } else if (event.key === 'ArrowUp') {
          newIndex =
            highlightedIndex === null || highlightedIndex === 0
              ? itemsCount - 1
              : highlightedIndex - 1;
        }
        onArrowsCallback(newIndex);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return (): void => window.removeEventListener('keydown', handleKeyPress);
  }, [highlightedIndex, itemsCount, onEnterCallback, onArrowsCallback]);
}

export default useListKeyboardNavigation;
